/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchEquipmentModelsResponse } from './search-equipment-models-response';


export interface SearchEquipmentModelsResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchEquipmentModelsResponse> | null;
}

